import { render, staticRenderFns } from "./RelatorioLogPraticasLinguagem.vue?vue&type=template&id=e500071a"
import script from "./RelatorioLogPraticasLinguagem.vue?vue&type=script&lang=js"
export * from "./RelatorioLogPraticasLinguagem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports